import { HttpClient, HttpParams } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export class CustomTranslateLoaderService implements TranslateLoader {
  constructor(private httpClient: HttpClient) {}

  /**
   * Keeping default behavior for the moment
   * When we decide to implement backend translation, we can call the api from this service
   */
  getTranslation(lang: string): Observable<any> {
    // to avoid that the browser caches json files
    const params = new HttpParams().append('nocache', new Date().getTime().toString(32));
    return this.httpClient.get(`assets/i18n/${lang}.json`, { params });
  }
}
